<template>
  <b-modal
    id="goodsReceiveDetailModal"
    ref="goodsReceiveDetailModal"
    size="xl"
    title="ใบรับสินค้า"
    no-close-on-backdrop
    @close="close"
    hide-footer
  >
    <div v-if="isLoading" class="text-center py-4">
      <b-spinner variant="primary"></b-spinner>
    </div>
    <div v-else class="gr-detail-layout">
      <!-- Left: metadata -->
      <div class="gr-detail-info">
        <div class="info-row">
          <span class="info-label">เลขที่เอกสาร:</span>
          <span class="info-value">{{ data.grCode }}</span>
        </div>
        <div class="info-row">
          <span class="info-label">รหัสใบสั่งซื้ออ้างอิง:</span>
          <span class="info-value">{{ data.poRefCode }}</span>
        </div>
        <div class="info-row">
          <span class="info-label">วันที่ทำรายการ:</span>
          <span class="info-value">{{ formatDate(data.createdAt) }}</span>
        </div>
        <div class="info-row">
          <span class="info-label">รหัสผู้ขาย:</span>
          <span class="info-value">{{ data.vendorCode }}</span>
        </div>
        <div class="info-row">
          <span class="info-label">ชื่อผู้ขาย:</span>
          <span class="info-value">{{ data.vendorName }}</span>
        </div>
        <div class="info-row">
          <span class="info-label">ชื่อสาขา:</span>
          <span class="info-value">{{ data.branchName || "-" }}</span>
        </div>
      </div>

      <!-- Right: items table -->
      <div class="gr-detail-table">
        <b-table
          id="grDetailTable"
          hover
          small
          responsive
          head-variant="light"
          :items="data.items"
          :fields="fields"
        >
          <template v-slot:cell(index)="row">{{ row.index + 1 }}.</template>
          <template v-slot:cell(productCode)="row">
            {{ row.item.productCode || row.item.product?.no || "-" }}
          </template>
          <template v-slot:cell(productName)="row">
            {{
              row.item.productNameMain || row.item.product?.description || "-"
            }}
          </template>
          <template v-slot:cell(quantity)="row">
            {{ Number(row.item.quantity).toLocaleString() }}
          </template>
          <template v-slot:cell(uomName)="row">
            {{ row.item.uomName || row.item.uom?.description || "-" }}
          </template>
          <template v-slot:cell(totalPrice)="row">
            {{ formatNumber(row.item.totalPrice) }}
          </template>
          <template v-slot:cell(lotNumber)="row">
            {{ row.item.lotNumber || "-" }}
          </template>
          <template v-slot:cell(expiredDt)="row">
            {{ row.item.expiredDt ? formatDate(row.item.expiredDt) : "-" }}
          </template>
        </b-table>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { THAI_MONTHS } from "@/constants";

export default {
  name: "GoodsReceiveDetail",
  data() {
    return {
      isLoading: false,
      data: {
        grCode: "",
        poRefCode: "",
        createdAt: "",
        vendorCode: "",
        vendorName: "",
        branchName: "",
        items: [],
      },
      fields: [
        {
          key: "index",
          label: "",
          thStyle: { width: "40px", minWidth: "40px" },
          class: "text-center",
        },
        {
          key: "productCode",
          label: "รหัส",
          thStyle: { minWidth: "100px" },
        },
        {
          key: "productName",
          label: "ชื่อสินค้า",
          thStyle: { minWidth: "160px" },
          tdClass: "product-name-cell",
        },
        {
          key: "quantity",
          label: "จำนวนสินค้า",
          thStyle: { minWidth: "100px" },
          class: "text-right",
        },
        {
          key: "uomName",
          label: "หน่วยสินค้า",
          thStyle: { minWidth: "100px" },
        },
        {
          key: "totalPrice",
          label: "ราคารวม (บาท)",
          thStyle: { minWidth: "120px" },
          class: "text-right",
        },
        {
          key: "lotNumber",
          label: "เลขล็อต",
          thStyle: { minWidth: "100px" },
          class: "text-right",
        },
        {
          key: "expiredDt",
          label: "วันหมดอายุ",
          thStyle: { minWidth: "120px" },
          class: "text-right",
        },
      ],
    };
  },
  methods: {
    show(goodsReceive) {
      // Show modal with list data, then fetch full details
      this.data = {
        grCode: goodsReceive.grCode || "",
        poRefCode: goodsReceive.poRefCode || "",
        createdAt: goodsReceive.createdAt || "",
        vendorCode: goodsReceive.vendorCode || "",
        vendorName: goodsReceive.vendorName || "",
        branchName: goodsReceive.branchName || "-",
        items: [],
      };
      this.$bvModal.show("goodsReceiveDetailModal");
      this.fetchDetail(goodsReceive.id);
    },
    fetchDetail(id) {
      this.isLoading = true;
      this.$store
        .dispatch("moduleGoodsReceive/fetchGoodsReceiveById", {
          clinicUrl: this.$route.params.clinicUrl,
          branchUrl: this.$route.params.branchUrl,
          id,
        })
        .then(detail => {
          if (detail) {
            this.data = detail;
          }
        })
        .catch(err => {
          console.error("fetchGoodsReceiveById failed", err);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    close() {
      this.$bvModal.hide("goodsReceiveDetailModal");
    },
    formatDate(dateStr) {
      if (!dateStr) return "";
      const date = new Date(dateStr);
      const day = date.getDate();
      const month = THAI_MONTHS[date.getMonth()];
      const year = String(date.getFullYear()).slice(-2);
      return `${day} ${month} ${year}`;
    },
    formatNumber(val) {
      if (val === null || val === undefined || val === "") return "-";
      return Number(val).toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
  },
};
</script>

<style scoped>
.gr-detail-layout {
  display: flex;
  gap: 24px;
  max-height: 70vh;
}

.gr-detail-info {
  flex: 0 0 280px;
  min-width: 0;
  position: sticky;
  top: 0;
  align-self: flex-start;
  border-right: 1px solid #dee2e6;
  padding-right: 24px;
}

.gr-detail-table {
  flex: 1;
  min-width: 0;
  overflow-y: auto;
  overflow-x: auto;
  max-height: 70vh;
}

.info-row {
  margin-bottom: 8px;
  line-height: 1.6;
  display: flex;
}

.info-label {
  font-weight: 600;
  color: #000;
}

.info-value {
  margin-left: 4px;
  word-break: break-word;
}

::v-deep #grDetailTable {
  table-layout: auto;
}

::v-deep #grDetailTable thead th {
  font-size: 0.85rem;
  white-space: nowrap;
}

::v-deep #grDetailTable tbody td {
  vertical-align: middle;
  font-size: 0.9rem;
  word-break: break-word;
  white-space: normal;
}

::v-deep #goodsReceiveDetailModal .modal-dialog {
  max-width: 1400px;
}

@media (max-width: 768px) {
  ::v-deep .modal-dialog {
    margin: 0.5rem;
    max-width: calc(100% - 1rem);
  }

  .gr-detail-layout {
    flex-direction: column;
    max-height: none;
  }

  .gr-detail-info {
    flex: none;
    position: static;
  }

  .gr-detail-table {
    max-height: 50vh;
  }

  ::v-deep #grDetailTable {
    table-layout: auto;
  }
}
</style>
